// extracted by mini-css-extract-plugin
module.exports = {"payment_options":"column_payment_options__l06Vj","bnpl_logo":"column_bnpl_logo__AnIhu","pay_later":"column_pay_later__yXlbo","container":"column_container__yX2fA"};